import React from 'react';

import { getCurrencySymbol } from 'utils/numbersFormat';

import { CURRENCY } from '../../../../__queries__';
import { useSelector } from '../../../Hooks';
import TextInput from '../TextInput';

export interface Props {
  name: string;
  value?: string;
  placeHolder?: string;
  handleChange?: (name, value) => void;
  disabled?: boolean;
  onBlur?: () => void;
}

const handlePriceFormat = (price) => {
  const strippedPrice = price.replace(' ', '');
  const formattedPrice = strippedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return formattedPrice;
};

const PriceInput: React.FC<Props> = ({
  name,
  value = '',
  placeHolder = '',
  handleChange,
  disabled = false,
  onBlur,
}) => {
  const currency = useSelector((state) => state.currency);

  const handleInputChange = (inputValue) => {
    if (!handleChange) return;
    // No other characters are allowed except numbers, comma and dot.
    // Only 1 comma or 1 dot is allowed.
    // There can only be 6 numbers, 8 if there is a comma or dot before the last two digits ex. 1000000,99
    // There can only be 1-2 digits after a comma or dot
    const regExp = /^[0-9][0-9\s]{0,6}(?:(\.|,)\d{0,2})?$/g;
    const validValue = regExp.test(inputValue);

    if (validValue || !inputValue.length) {
      handleChange(name, handlePriceFormat(inputValue));
    }
  };

  const style: any = { textAlign: 'right', paddingRight: '36px', paddingLeft: '4px' };
  if (disabled) {
    style.backgroundColor = 'transparent';
    style.pointerEvents = 'none';
  }

  return (
    <TextInput
      name={name}
      type="text"
      value={handlePriceFormat(value.toString())}
      handleChange={(e) => handleInputChange(e.target.value)}
      onBlur={onBlur}
      style={style}
      currency={getCurrencySymbol(currency as keyof typeof CURRENCY)}
      tabIndex={disabled ? -1 : 0}
    />
  );
};

export default PriceInput;
